export default __webpack_public_path__ + "static/media/guide_arm.e5e952ef.png";